import React from "react";
import { Box } from "@mui/material";

export const BetaBox = (): JSX.Element => {
  return (
    <Box
      sx={{
        background:
          "linear-gradient(106.08deg, #D8D8FF -94.22%, #ECF9FF 108.81%)",
        fontSize: "13px",
        borderRadius: 16,
        mx: 2,
        py: 0.5,
        px: 1,
      }}
    >
      BETA
    </Box>
  );
};
